const dictionary = {
    bannerHome: "BannerHome",
    bannerPage: "BannerPagina",
    blocos: "BlockTextoImagem",
    citacao: "Citacao",
    contato: "BlockContato",
    galeriaGeral: "Galeria",
    gallery_onlyImages: "GaleriaSimples",
    gallery_textImages_1: "GaleriaNavLateral",
    gallery_textImages_2: "GaleriaNavLateral",
    gallery_textImagesSimple: "GaleriaNavVertical",
    gallery_textWithImagesCircle: "BlockTextoCarrousel",
    gastronomia: "Gastronomia",
    grandeBloco: "BlockTextoImagemFull",
    image: "Imagem",
    imagemLista: "ImagemELegendas",
    informacoes: "BlockTextoInformacoes",
    localizacao: "BlockLocalizacao",
    planos: "BlockPlanos",
    textos: "TextoSimples",
    tituloPage: "BlockTitulo",
    tratamento: "Tratamento",
    // galeriaImg: "GaleriaSimples",
    // galeriaFilosofiaTexto: "BlockTextoGaleria",
    // imagem: "GaleriaSimples",
    // galeriaImgTexto: "GaleriaSimples",
}

const components = {
    Aside: () => import( /* webpackChunkName: "Aside" */ '@components/Aside/Aside'),
    AsideVideo: () => import( /* webpackChunkName: "AsideVideo" */ '@components/AsideVideo/AsideVideo'),
    AsideImage: () => import( /* webpackChunkName: "AsideImage" */ '@components/AsideImage/AsideImage'),
    BannerHome: () => import( /* webpackChunkName: "BannerHome" */ '@sections/Home/Banner/Banner'),
    BannerPagina: () => import( /* webpackChunkName: "BannerPagina" */ '@sections/Pagina/Banner/Banner'),
    BlockContato: () => import( /* webpackChunkName: "BlockContato" */ '@components/BlockContato/BlockContato'),
    BlockLocalizacao: () => import( /* webpackChunkName: "BlockLocalizacao" */ '@components/BlockLocalizacao/BlockLocalizacao'),
    BlockPlanos: () => import( /* webpackChunkName: "BlockPlanos" */ '@components/BlockPlanos/BlockPlanos'),
    BlockTextoCarrousel: () => import( /* webpackChunkName: "BlockTextoCarrousel" */ '@components/BlockTextoCarrousel/BlockTextoCarrousel'),
    BlockTextoImagem: () => import( /* webpackChunkName: "BlockTextoImagem" */ '@components/BlockTextoImagem/BlockTextoImagem'),
    BlockTextoImagemFull: () => import( /* webpackChunkName: "BlockTextoImagemFull" */ '@components/BlockTextoImagemFull/BlockTextoImagemFull'),
    BlockTextoInformacoes: () => import( /* webpackChunkName: "BlockTextoInformacoes" */ '@components/BlockTextoInformacoes/BlockTextoInformacoes'),
    BlockTitulo: () => import( /* webpackChunkName: "BlockTitulo" */ '@components/BlockTitulo/BlockTitulo'),
    Citacao: () => import( /* webpackChunkName: "Citacao" */ '@components/Citacao/Citacao'),
    FormularioContato: () => import( /* webpackChunkName: "FormularioContato" */ '@components/FormularioContato/FormularioContato'),
    Galeria: () => import( /* webpackChunkName: "Galeria" */ '@components/Galeria/Galeria'),
    GaleriaNavLateral: () => import( /* webpackChunkName: "GaleriaNavLateral" */ '@components/GaleriaNavLateral/GaleriaNavLateral'),
    GaleriaNavVertical: () => import( /* webpackChunkName: "GaleriaNavVertical" */ '@components/GaleriaNavVertical/GaleriaNavVertical'),
    GaleriaSimples: () => import( /* webpackChunkName: "GaleriaSimples" */ '@components/GaleriaSimples/GaleriaSimples'),
    Gastronomia: () => import( /* webpackChunkName: "Gastronomia" */ '@components/Gastronomia/Gastronomia'),
    Imagem: () => import( /* webpackChunkName: "Imagem" */ '@components/Imagem/Imagem'),
    ImagemELegendas: () => import( /* webpackChunkName: "ImagemELegendas" */ '@components/ImagemELegendas/ImagemELegendas'),
    Informacoes: () => import( /* webpackChunkName: "Informacoes" */ '@components/Informacoes/Informacoes'),
    Mapa: () => import( /* webpackChunkName: "Mapa" */ '@components/Mapa/Mapa'),
    Plano: () => import( /* webpackChunkName: "Plano" */ '@components/Plano/Plano'),
    TextoSimples: () => import( /* webpackChunkName: "TextoSimples" */ '@components/TextoSimples/TextoSimples'),
    Titulo: () => import( /* webpackChunkName: "Titulo" */ '@components/Titulo/Titulo'),
    Tratamento: () => import( /* webpackChunkName: "Tratamento" */ '@components/Tratamento/Tratamento'),
}

export {
    components,
    dictionary,
}